import React from 'react';
import authRoles from 'app/auth/authRoles';

const DataDirectoryConfig = {
  settings: {
    layout: {}
  },
  routes: [
    {
      path: '/data-directory/company-profile',
      auth: authRoles.dataDirectory,
      component: React.lazy(() => import('./company-profile/CompanyProfile'))
    },
    {
      path: '/data-directory/lead-sources',
      auth: authRoles.dataDirectory,
      component: React.lazy(() => import('./lead-sources/LeadSources'))
    },
    {
      path: '/data-directory/lead-source/:leadSourceId',
      auth: authRoles.dataDirectory,
      component: React.lazy(() => import('./lead-source/LeadSource'))
    },
    {
      path: '/data-directory/title-companies',
      auth: authRoles.dataDirectory,
      component: React.lazy(() => import('./title-companies/TitleCompanies'))
    },
    {
      path: '/data-directory/title-company/:titleCompanyId',
      auth: authRoles.dataDirectory,
      component: React.lazy(() => import('./title-company/TitleCompany'))
    },
    {
      path: '/data-directory/lenders',
      auth: authRoles.dataDirectory,
      component: React.lazy(() => import('./lenders/Lenders'))
    },
    {
      path: '/data-directory/lender/:lenderId',
      auth: authRoles.dataDirectory,
      component: React.lazy(() => import('./lender/Lender'))
    }
  ]
};

export default DataDirectoryConfig;
